import { Box, Icon } from "@outschool/backpack";
import { SearchFilters as SearchFiltersType } from "@outschool/gql-backend-generated";
import { faSlidersH } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { ToggleButton } from "@outschool/ui-legacy-component-library";
import React from "react";

import ListingFilters from "./filters/ListingFilters";
import { SearchInputModal } from "./SearchInputModal";

type SearchProps = {
  performSearch: (insideModal: boolean) => void;
  searchFilters: SearchFiltersType;
  updateSearchFilters: (filterType: string, filters: SearchFiltersType) => void;
  searchUid?: string;
};

export type UpdatedFilterProps = {
  type: string;
  filter: SearchFiltersType;
};

export const extractFilter = (filters: SearchFiltersType, val: string) => {
  // @ts-ignore
  return filters[val] && filters[val]?.toString()?.length ? filters[val] : null;
};

export function FilterMenuToggle(searchProps: SearchProps) {
  const [showModal, setShowModal] = React.useState(false);

  const { performSearch, updateSearchFilters, searchFilters, searchUid } =
    searchProps;

  const onApply = ({ type, filter }: UpdatedFilterProps) => {
    updateSearchFilters(type, filter);
    setShowModal(false);
    performSearch(true);
  };
  const { t } = useTranslation(
    "client\\components\\search\\mobile\\FilterMenuToggle"
  );

  return (
    <Box flex>
      <ToggleButton
        enabled={true}
        sx={{
          flex: 1,
          marginRight: "5px",
          width: "50%",
          height: "40px",
          paddingX: "1.25em",
          fontSize: "14px"
        }}
        onClick={() => {
          setShowModal(true);
        }}
      >
        <Icon
          sx={{
            marginRight: "5px"
          }}
          icon={faSlidersH}
        />
        {t("Filters")}
      </ToggleButton>
      {showModal && (
        <SearchInputModal
          open={true}
          onClose={() => {
            setShowModal(false);
          }}
          onOpen={() => {
            setShowModal(true);
          }}
        >
          <ListingFilters
            onApply={onApply}
            searchFilters={searchFilters}
            searchUid={searchUid}
          />
        </SearchInputModal>
      )}
    </Box>
  );
}
